export const ValidatePhoneField = (value?: string) => {
  if (value && value.length) {
    var test = replacePhoneNumber(value);
    if (test && test.length) {
      var reg = regexPhoneNumber();
      return reg.test(test);
    }
  }
  return false;
};

export const ValidateNonVietnamese = (value: string | undefined) => {
  if (value && value?.length) {
    var reg = regexNonVietnamese();
    return reg.test(value);
  }
  return false;
};

export const ValidateExceptMark = (value: string | undefined) => {
  if (value && value?.length) {
    let reMax = /^[a-zA-Z0-9]+$/;
    return reMax.test(String(value).toLowerCase());
  }
  return false;
};

export const ValidateExceptMarkSpaceDot = (value: string | undefined) => {
  if (value && value?.length) {
    const str = value.replace(/[\u2212\u002D\u00AD\u05BE\u2011\u2012\u2013\u2014\u2015\u207B\u208B\u2212\uFE58\uFE63\uFF0D]/, "-");
    let re = /^[a-zA-Z0-9.\-\s]+$/;
    return re.test(str);
  }
  return false;
};

export const ValidateSpace = (value: string | undefined) => {
  if (value && value?.length) {
    let reMax = /^[\s]+$/;
    return reMax.test(String(value).toLowerCase());
  }
  return false;
};

export const ValidatePassword = (value: string | undefined) => {
  if (value && value?.length) {
    let reMax = /^(((?=.*?[A-Z])(?=.*?[a-z]))|((?=.*?[A-Z])(?=.*?[^\w\s]))|((?=.*?[a-z])(?=.*?[^\w\s])))(?=.*?[0-9]).{6,}$/;
    return reMax.test(String(value));
  }
  return false;
};

export const regexNonVietnamese = () => {
  return /À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ|È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ|Ì|Í|Ị|Ỉ|Ĩ|Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ|Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ|Ỳ|Ý|Ỵ|Ỷ|Ỹ|Đ|à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ|è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ|ì|í|ị|ỉ|ĩ|ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ|ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ|ỳ|ý|ỵ|ỷ|ỹ|đ|\u0300|\u0301|\u0303|\u0309|\u0323|\u02C6|\u0306|\u031B/g;
};

export const replacePhoneNumber = (value?: string) => {
  if (value && value.length) {
    const rateArray = value.trim().split(" ");
    let str: string = "";
    rateArray.forEach((item) => {
      if (item === "") return;
      str = str + item;
    });
    return str
      .replace(/^\s+|\s+$/g, "")
      .replace("+84", "0")
      .replace(/^84/g, "0");
  }
  return "";
};

export const covertPhoneNumVietNam = (value?: string) => {
  if (value && value.length && value.indexOf("0") === 0) {
    return "84" + value.substring(1, value.length);
  }
  return value;
};

export const regexPhoneNumber = () => {
  return /((^(\+84|84|0|0084){1})(3|5|7|8|9))+([0-9]{8})$/;
};

export const regexEmail = () => {
  return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
};

export const regexCharacterMark = () => {
  return /^[a-zA-Z0-9.\-\s]+$/;
};

export const regexCharacterMarkSpaceDot = () => {
  return /^[a-zA-Z0-9.\-\s]+$/;
};

export const regexPassword = () => {
  return /^(((?=.*?[A-Z])(?=.*?[a-z]))|((?=.*?[A-Z])(?=.*?[^ws]))|((?=.*?[a-z])(?=.*?[^ws])))(?=.*?[0-9])(?!.*[s]).{6,}$/;
};

export const regexNumber = () => {
  return /^[0-9]+$/;
};

export const regexValidName = () => {
  return /[!@#$%^&*(),?":{}|<>]/g;
};
export const matchSpecialCharacter = (value: string) => {
  return value.match(/[!@#$%^&*+=._-]/g);
};

export const replaceDash = (value?: string) => {
  if (value && value.length) {
    return value.replace(/[\u2212\u002D\u00AD\u05BE\u2011\u2012\u2013\u2014\u2015\u207B\u208B\u2212\uFE58\uFE63\uFF0D]/, "-");
  }
  return "";
};

export const replaceSpace = (value?: string) => {
  if (value?.length) {
    const rateArray = value.trim().split(" ");
    let str: string = "";
    rateArray.forEach((item) => {
      if (item === "") return;
      if (str === "") {
        str = item;
        return;
      }
      str = str + " " + item;
    });
    return str;
  }
  return "";
};

export const replaceEnterKey = (value?: string) => {
  if (value && value.length) {
    return value.replace(/(\r\n|\n|\r)/gm, " ");
  }
  return "";
};

export const nonAccentVietnamese = (str?: string) => {
  if (str && str.length) {
    str = str.trim();
    str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, "A");
    str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, "E");
    str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, "I");
    str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, "O");
    str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, "U");
    str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, "Y");
    str = str.replace(/Đ/g, "D");
    str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
    str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
    str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
    str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
    str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
    str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
    str = str.replace(/đ/g, "d");
    // Some system encode vietnamese combining accent as individual utf-8 characters
    str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, ""); // Huyền sắc hỏi ngã nặng
    str = str.replace(/\u02C6|\u0306|\u031B/g, ""); // Â, Ê, Ă, Ơ, Ư
  } else str = "";
  return str;
};

export const removeVietnameseAndPunctuations = (str?: string) => {
  if (str && str.length) {
    str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g,"a"); 
    str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g,"e"); 
    str = str.replace(/ì|í|ị|ỉ|ĩ/g,"i"); 
    str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g,"o"); 
    str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g,"u"); 
    str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g,"y"); 
    str = str.replace(/đ/g,"d");
    str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, "A");
    str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, "E");
    str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, "I");
    str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, "O");
    str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, "U");
    str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, "Y");
    str = str.replace(/Đ/g, "D");
    // Some system encode vietnamese combining accent as individual utf-8 characters
    // Một vài bộ encode coi các dấu mũ, dấu chữ như một kí tự riêng biệt nên thêm hai dòng này
    str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, ""); // ̀ ́ ̃ ̉ ̣  huyền, sắc, ngã, hỏi, nặng
    str = str.replace(/\u02C6|\u0306|\u031B/g, ""); // ˆ ̆ ̛  Â, Ê, Ă, Ơ, Ư
    // Remove extra spaces
    // Bỏ các khoảng trắng liền nhau
    str = str.replace(/ + /g," ");
    // Bỏ xuống dòng/ tab
    str = str.replace(/(\r\n|\n|\r)/gm, " ")
    str = str.trim();
    // Remove punctuations
    // Bỏ dấu câu, kí tự đặc biệt
    str = str.replace(/!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'|\"|\&|\#|\[|\]|~|\$|_|`|-|{|}|\||\\/g," ");
    str = str.replace(/[\u2212\u002D\u00AD\u05BE\u2011\u2012\u2013\u2014\u2015\u207B\u208B\u2212\uFE58\uFE63\uFF0D]/, " ");
  } else str = "";
  return str;
};

export function getTwoCharacterFromName(name: string = ""): string {
  let _name = "";
  nonAccentVietnamese(name)
    .split("")
    .reverse()
    .map((letter) => {
      if (letter === letter.toUpperCase()) {
        if (_name.length > 2) {
          return;
        }
        _name = _name + letter;
      }
      return _name;
    })
    .reverse();
  return _name.replace(" ", "").split("").reverse().toLocaleString().replace(",", "");
}
